module.exports = __webpack_public_path__ + "static/media/notification_guidance_2.59c7d461.jpg";